<!-- 添加建筑表单 -->
<template>
    <el-dialog :title="title" :visible.sync="visible" width="700px" :before-close="handleCloseDialog">
        <el-form :inline="true" :model="buildForm" ref="buildForm" class="demo-form-inline" label-width="60px">
            <div v-for="(v, i) in buildForm.items" :key="i">
                <el-form-item label="名称"
                    :prop="'items.' + i + '.modulename'"
                    :rules="{
                        required: true, message: '名称不能为空', trigger: 'blur'
                    }"
                >
                    <el-input v-model="v.modulename" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="v.description" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item v-if="i>0">
                    <el-button type="text" icon="el-icon-delete" @click="handleReduce(v, i)"></el-button>
                </el-form-item>
            </div>
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" @click="handleAdd">增加</el-button>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Service from '@/api/Service'
export default {
    name:  'CmpBuildform',
    props: ["visible", "addForm", "hBreadcrumb"],
    data() {
        return {
            buildForm: {
                items: [{
                    modulename: '',
                    description: '',
                }],
            },
            title:'',
      };
    },

    watch: {
        visible(newVal) {
            // console.log("visible", newVal);
            if(newVal) {
                this.handleInitData();
            }
        },
        addForm(mewVal) {
            // this.handleInitData();
        },
        hBreadcrumb(mewVal) {
            // this.handleInitData();
        }
    },
    mounted() {
        this.handleInitData()
    },

    methods: {
        // 初始化数据
        handleInitData() {
            // console.log("初始化数据:",JSON.stringify(this.addForm));
            let title = '';
            this.hBreadcrumb.map(v=>{
                title += v.modulename + " > "
            })
            title += "新增" + this.addForm.typename
            this.title = title;
        },
        // 关闭弹框
        handleCloseDialog() {
            this.$emit("handleCloseDialog", false);
            this.resetForm('buildForm');
        },
        // 增加一行
        handleAdd() {
            this.buildForm.items.push({
                modulename: '',
                description: '',
            })
        },
        // 减少当前行
        handleReduce(v, index){
            this.buildForm.items.splice(index,1);
        },
        // 保存表单
        async handleSave() {
            this.$refs['buildForm'].validate(async (valid) => {
                if (valid) {
                    let params = this.getParams();
                    let data = await Service.addBuildList(params);
                    if(data) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!',
                            duration: 1500,
                            onClose: ()=>{
                                this.$emit("handleCloseDialog", true);
                                this.resetForm('buildForm')
                            }
                        });
                    }
                } else {
                    return false;
                }
            })
        },
        // 重置表单
        resetForm(formname) {
            this.$refs[formname].resetFields();
            this.$nextTick(() => {
                // 重置表单
                this.buildForm.items = [{
                    modulename: '',
                    description: '',
                }]
            });
        },
        // 添加参数
        getParams() {
            let list = this.buildForm.items;
            let obj = Object.assign({}, this.addForm, {list:list})
            return obj;
        }
    }
}

</script>
<style lang='less' scoped>

</style>